var _rect, _rect2, _rect3, _rect4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.6,
    y: 0.6,
    width: 16.8,
    height: 4.8,
    rx: 2.4,
    fill: "white",
    stroke: "#D9D9D9",
    strokeWidth: 1.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.6,
    y: 5.6,
    width: 16.8,
    height: 4.8,
    rx: 2.4,
    fill: "white",
    stroke: "#D9D9D9",
    strokeWidth: 1.2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.6,
    y: 10.6,
    width: 16.8,
    height: 4.8,
    rx: 2.4,
    fill: "white",
    stroke: "#D9D9D9",
    strokeWidth: 1.2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0.6,
    y: 15.6,
    width: 16.8,
    height: 4.8,
    rx: 2.4,
    fill: "white",
    stroke: "#EF4948",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLow);
export default __webpack_public_path__ + "static/media/low.c42bf0b00f1cef7afe7d70cd0c61dd59.svg";
export { ForwardRef as ReactComponent };